import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  RouterProvider,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import '@marqvision/mds/css/fonts.css';
import { folioClientRouter } from '~/Router';
import reportWebVitals from './reportWebVitals';
import './index.css';

export const queryClient = new QueryClient();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN_KEY,
  environment: process.env.REACT_APP_SENTRY_ENV,
  integrations: [
    new Sentry.BrowserTracing({
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      ),
    }),
    new Sentry.Replay({
      // Additional SDK configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  release: process.env.npm_package_version,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: ['production'].includes(process.env.REACT_APP_SENTRY_ENV ?? '') ? 0.1 : 0,
  sampleRate: ['production', 'pre-release', 'staging'].includes(process.env.REACT_APP_SENTRY_ENV ?? '') ? 1.0 : 0,
});

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

root.render(
  <QueryClientProvider client={queryClient}>
    <RouterProvider router={folioClientRouter} />
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
